// apps/web/src/features/onboarding/pages/ThankYouPage.tsx
import { Box, Typography } from "@mui/material";
import { OnboardingStepLayout } from "./../../../shared/ui/index";
import { useTranslation } from "react-i18next";

export default function ThankYouPage() {
  const { t, i18n } = useTranslation();

  const handleBackToSite = () => {
    const isPortuguese = (i18n.resolvedLanguage ?? i18n.language)
      .toLowerCase()
      .startsWith("pt");

    window.location.href = isPortuguese
      ? "https://atlante.energy/pt-pt/"
      : "https://atlante.energy";
  };

  return (
    <OnboardingStepLayout
      step={5}
      totalSteps={5}
      showProgress={false}
      title={t("onboarding.thankYou.title")}
      onNext={handleBackToSite}
      nextLabel={t("onboarding.thankYou.actions.backToSite")}
    >
      <Box sx={{ maxWidth: 520 }}>
        <Typography
          sx={{
            fontSize: "0.95rem",
            color: "#4A5568",
            mb: 2,
          }}
        >
          {t("onboarding.thankYou.text.line1")}
        </Typography>

        <Typography
          sx={{
            fontSize: "0.95rem",
            color: "#4A5568",
            mb: 2,
          }}
        >
          {t("onboarding.thankYou.text.line2")}
        </Typography>

        <Typography
          sx={{
            fontSize: "0.95rem",
            color: "#4A5568",
            whiteSpace: "pre-line",
          }}
        >
          {t("onboarding.thankYou.text.footer")}
        </Typography>
      </Box>
    </OnboardingStepLayout>
  );
}
